export default "__VITE_ASSET__dVKcaZwK__"